import { useEffect, useState } from "react";
import ModalElement from "../../../Common/ModalElement";
import ButtonElement from "../../../Common/ButtonElement";
import InputElememt from "../../../Common/InputElement";
import SearchableDropdown from "../../../Common/SearchDropdown";
import { formatListItems } from "../../../utils";

const VehicleStatus = ({ show, vehicleActions, hideModal, vehicleData, statusAction, loading }) => {
    const [selected, setSelected] = useState(null);
    const [actions, setActions] = useState([]);
    const [remark, setRemark] = useState("");

    useEffect(() => {
        if(vehicleActions?.length) {
            const key = "ENABLE";
            const filteredActions = vehicleActions?.filter(item => {
                if(vehicleData?.isActive) return item?.action_code != key;
                else return item?.action_code == key;
            });
            setActions(formatListItems(filteredActions, "action_id", "action_label"));
        }
    }, [vehicleActions, vehicleData]);

    return <ModalElement size="lg" show={show} title={`Vehicle Action Required`} onHide={hideModal}>
        <div className="text-start">
            <div className="installer-personal mb-3">
                <div className="d-flex justify-content-between align-items-center me-2">
                    <h5 className="mb-2">{`Taking action for vehicle ${vehicleData?.vehicleRegno ?? ""}. Select the appropriate action and provide details.`}</h5>
                </div>
                <div className="my-2">
                    <SearchableDropdown
                        placeholder={"Select Reason"}
                        value={selected?.action_label}
                        error={false}
                        options={actions}
                        onSelect={(value) => setSelected(value)}
                    />
                </div>

                <div className="col-12 my-2">
                    <InputElememt
                        isTextArea={true}
                        isRequired={false}
                        label={"Remark"}
                        placeholder={"Enter your remark here"}
                        name={"remark"}
                        value={remark}
                        error={false}
                        onChange={(e) => setRemark(e.target.value)}
                    />
                </div>
                {selected?.action_code ? <div
                    className="alert d-flex flex-column my-2"
                    style={{
                        borderLeft: '5px solid #dc3545',
                        backgroundColor: '#f8d7da',
                        color: '#721c24',
                        padding: '1rem',
                        borderRadius: '4px',
                        marginBottom: '1rem',
                    }}
                    role="alert">
                    <strong className="mb-1">Actions to be performed</strong>
                    {selected?.actions_to_perform?.split('\\n').map((line, index) => (
                        <div key={index}>{line}</div>
                    ))}
                </div> : null}
            </div>
            <div className="submit-btn text-center mb-3">
                <ButtonElement text={"Confirm Action"} cssClass="small-radius mb-1" onClick={() => statusAction(selected?.action_id, remark)} variant="btn-outline-primary" loading={loading} disabled={!selected?.action_id} />
            </div>
        </div>
    </ModalElement>
}
export default VehicleStatus;